import { Avatar, Checkbox, TooltipPortalTrigger } from 'components';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class PersonCard extends Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    picURL: PropTypes.string,
    color: PropTypes.string,
    type: PropTypes.oneOf(['kid', 'teacher', 'lead']),
    validationError: PropTypes.string,
    disableInvalid: PropTypes.bool,
    selected: PropTypes.bool,
    onSelect: PropTypes.func,
    roleName: PropTypes.string,
    status: PropTypes.string,
    allergy: PropTypes.any
  };

  static defaultProps = {
    type: 'kid',
    selected: false,
    disableInvalid: true
  };

  shouldComponentUpdate(nextProps) {
    return this.props.selected !== nextProps.selected || this.props.roleName !== nextProps.roleName;
  }

  @bind
  handleSelect() {
    if (this.props.onSelect) {
      this.props.onSelect(this.props.id);
    }
  }

  render() {
    const {
      status,
      name,
      picURL,
      selected,
      color,
      validationError,
      disableInvalid,
      type,
      id,
      allergy,
      roleName
    } = this.props;

    const isInvalid = validationError !== undefined && disableInvalid;
    const hasRoleName = Boolean(roleName && String(roleName).trim());
    const hasValidation = validationError != null && String(validationError).trim() !== '';

    return (
      <div className="person-card" data-cy={`person-card-${id}`}>
        {validationError !== undefined ? (
          <TooltipPortalTrigger
            tooltip={validationError}
            side="center"
            portalClassName="person-card-tooltip select-person-tooltip"
          >
            <Checkbox
              disabled={isInvalid}
              className="person-card__checkbox"
              checked={selected}
              onChange={this.handleSelect}
            />
          </TooltipPortalTrigger>
        ) : (
          <Checkbox
            disabled={isInvalid}
            className="person-card__checkbox"
            checked={selected}
            onChange={this.handleSelect}
          />
        )}

        <div className="person-card__info" onClick={!isInvalid ? this.handleSelect : undefined}>
          <Avatar
            className="person-card__avatar"
            url={picURL}
            color={color}
            size="small"
            type={type === 'teacher' ? 'avatar' : undefined}
            status={status}
            name={name}
            allergy={allergy}
          />

          <div className="person-card__text">
            <div className="person-card__name">{name}</div>
            {hasRoleName && <div className="person-card__role">{roleName}</div>}

            {!hasRoleName && hasValidation && (
              <div className="person-card__label person-card__label--error">{validationError}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default PersonCard;
